import React from "react";
import { useLang } from "../context/LanguageContext";
import { images } from "../mock";
import { ArrowRight, ChevronDown } from "lucide-react";

export default function Hero() {
  const { t } = useLang();
  const h = t.hero;

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={images.heroControlRoom}
          alt="Central de monitoreo Grupo RPC"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 pt-28 pb-20 w-full">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#f5871f]/50 bg-[#f5871f]/10 px-4 py-1.5 text-[#f5b061] text-xs font-700 uppercase tracking-widest font-display">
            <span className="w-2 h-2 rounded-full bg-[#f5871f] live-dot" />
            {h.badge}
          </span>

          <h1 className="mt-6 font-display font-700 text-white leading-[0.95] text-5xl md:text-7xl uppercase">
            {h.titleTop}{" "}
            <span className="text-[#f5871f]">{h.titleAccent}</span>
          </h1>

          <p className="mt-6 text-white/80 text-lg md:text-xl leading-relaxed max-w-2xl">
            {h.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo("#contacto")}
              className="btn-orange inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-700 uppercase tracking-wide font-display"
            >
              {h.ctaPrimary}
              <ArrowRight className="w-5 h-5" />
            </button>
            <button
              onClick={() => scrollTo("#servicios")}
              className="inline-flex items-center gap-2 rounded-full border border-white/30 text-white px-7 py-3.5 text-base font-700 uppercase tracking-wide font-display hover:bg-white/10 transition-colors"
            >
              {h.ctaSecondary}
            </button>
          </div>

          {/* Stats */}
          <div className="mt-14 flex flex-wrap gap-8 md:gap-12">
            {h.stats.map((s, i) => (
              <div key={i} className="border-l-2 border-[#f5871f] pl-4">
                <div className="font-display font-700 text-white text-3xl md:text-4xl">{s.value}</div>
                <div className="text-white/60 text-xs md:text-sm uppercase tracking-widest mt-1 font-display">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo("#servicios")}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-white/60 hover:text-white transition-colors"
        aria-label="Scroll"
      >
        <ChevronDown className="w-7 h-7 animate-bounce" />
      </button>
    </section>
  );
}
